/**
 * Device Breakpoints
 * @description Breakpoints for responsive design
 * @enum {string}
 * @readonly
 * @property {string} MOBILE - Mobile breakpoint
 * @property {string} TABLET - Tablet breakpoint
 * @property {string} DESKTOP - Desktop breakpoint
 * @property {string} LARGE_DESKTOP - Large desktop breakpoint
 */
export var DeviceBreakpointsType;
(function (DeviceBreakpointsType) {
    DeviceBreakpointsType["MOBILE"] = "MOBILE";
    DeviceBreakpointsType["TABLET"] = "TABLET";
    DeviceBreakpointsType["DESKTOP"] = "DESKTOP";
    DeviceBreakpointsType["LARGE_DESKTOP"] = "LARGE_DESKTOP";
})(DeviceBreakpointsType || (DeviceBreakpointsType = {}));
/**
 * Utility functions for checking device breakpoint types.
 * These helpers allow you to easily determine if a given DeviceBreakpointsType
 * matches a specific device category (mobile, tablet, desktop, etc).
 */
export const DeviceBreakpointsTypeUtils = {
    /**
     * Returns true if the device is a mobile device.
     */
    isMobile: (device) => device === DeviceBreakpointsType.MOBILE,
    /**
     * Returns true if the device is a tablet device.
     */
    isTablet: (device) => device === DeviceBreakpointsType.TABLET,
    /**
     * Returns true if the device is either mobile or tablet.
     */
    isMobileOrTablet: (device) => DeviceBreakpointsTypeUtils.isMobile(device) || DeviceBreakpointsTypeUtils.isTablet(device),
    /**
     * Returns true if the device is a desktop device.
     */
    isDesktop: (device) => device === DeviceBreakpointsType.DESKTOP,
    /**
     * Returns true if the device is a large desktop device.
     */
    isLargeDesktop: (device) => device === DeviceBreakpointsType.LARGE_DESKTOP,
    /**
     * Returns true if the device is either desktop or large desktop.
     */
    isDesktopOrLargeDesktop: (device) => DeviceBreakpointsTypeUtils.isDesktop(device) ||
        DeviceBreakpointsTypeUtils.isLargeDesktop(device),
};
//# sourceMappingURL=breakpoints.js.map